import { INITIAL_STATE } from './state';
import { UserActions } from './types';
export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case UserActions.STATE_UPDATE:
            return update(state, action);
        case UserActions.STATE_RESET:
            return reset(state);
        default:
            return state;
    }
}
function update(state, action) {
    return {
        ...state,
        ...action.payload,
    };
}
function reset(state) {
    return {
        ...state,
        state: {
            ...INITIAL_STATE.state,
        },
    };
}
